<template>
  <div class="payout-event-detail">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <strong v-translate translate-context="payout.eventDetail">Events detail</strong>
      <CButton
        color="light"
        variant="outline"
        size="sm"
        @click="$emit('download')"
      >
        <CIcon name="cipDoc" size="sm" class="mr-1" />
        <translate translate-context="payout.eventDetail">Export</translate>
      </CButton>
    </div>

    <CDataTable
      :items="picaServices"
      :fields="fields"
      class="table-payout-event"
      :no-items-view="{ noResults: $pgettext('payout.eventDetail', 'No events') }"
    >
      <template #name="{item}">
        <td>
          <div class="font-weight-medium mb-1">{{ item.name }}</div>
          <div class="small" v-if="item.event_date">
            <CIcon name="cipCalendar" size="custom-size" :height="18" class="mr-1" style="vertical-align: bottom;" />
            {{ item.event_date|formatDate('L') }}
          </div>
        </td>
      </template>

      <template #refunds="{item}">
        <td class="text-center">
          <div class="font-weight-semi-bold text-warning">
            <span v-if="item.refunds && parseFloat(item.refunds) > 0" class="text-danger">
              {{ item.refunds | currency(currency) }}
            </span>
            <span v-else>---</span>
          </div>
          <div class="small"><translate translate-context="payout.eventDetail">Refunds</translate></div>
        </td>
      </template>

      <template #paid_gross="{item}">
        <td class="text-right">
          <div class="font-weight-semi-bold text-success" style="font-size: 16px">
            {{ item.paid_gross | currency(currency) }}
          </div>
          <div class="small">
            <translate translate-context="payout.eventDetail">Revenue generated</translate>
          </div>
        </td>
      </template>

    </CDataTable>
  </div>
</template>

<script>
export default {
  name: 'PayoutEventDetail',
  props: {
    picaServices: {
      type: Array,
      default: () => []
    },
    currency: {
      type: String,
      default: 'EUR'
    },
  },
  computed: {
    fields() {
      return [
        {
          key: 'name',
          label: this.$pgettext('payout.eventDetail', 'Evento')
        },
        {
          key: 'refunds',
          label: this.$pgettext('payout.eventDetail', 'Rimborsi'),
          _classes: 'text-center',
          _style: 'width: 120px'
        },
        {
          key: 'paid_gross',
          label: this.$pgettext('payout.eventDetail', 'Ricavo lordo'),
          _classes: 'text-right',
          _style: 'width: 160px'
        }
      ]
    }
  }
}
</script>

